import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  CloseSidenav,
  EditFlow,
  EditMode,
  EditModeAdvanced,
  OpenSidenav,
  ViewFlow,
} from '../actions/sidenav.actions';
import { SideNavState } from '../models/flows.model';

const initialState: SideNavState = {
  sidenavStatus: false,
  createFlow: false,
  view: true,
  isAdvanced: false,
};

export const SideNavReducer = createReducer(
  initialState,
  on(OpenSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
  })),
  on(ViewFlow, (state) => ({
    ...state,
    view: true,
  })),
  on(EditFlow, (state, { isAdvanced }) => ({
    ...state,
    view: false,
    isAdvanced: isAdvanced ? true : false,
  })),
  on(EditModeAdvanced, (state) => ({
    ...state,
    view: false,
    isAdvanced: true,
  })),
  on(EditMode, (state) => ({
    ...state,
    view: false,
    isAdvanced: false,
  })),
  on(ActiveComponentChanged, () => initialState),
);
